// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.provide-feedback {
	padding: 16px;
	font-size: 15px;
}

.provide-feedback select {
	height: 36px;
	border: 1px solid #999;
	font-size: 14px;
	margin: 8px 0;
	border-radius: 5px;
	box-sizing: border-box;
}

.provide-feedback button[type=submit] {
	border: 1px solid #4f638d;
	background: #4f638d;
	color: #FFF;
	height: 36px;
	font-size: 17px;
	line-height: 36px;
	border-radius: 5px;
	padding: 0 20px;
	box-sizing: border-box;
	cursor: pointer;
}

.provide-feedback textarea {
	width: 100%;
	border: 1px solid #999;
	font-size: 14px;
	margin-bottom: 8px;
	border-radius: 5px;
	box-sizing: border-box;
}

.provide-feedback .success {
	color: #0B6623;
}

.provide-feedback .error {
	color: #AB1F2B;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Views/ProvideFeedback.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,sBAAsB;CACtB,eAAe;CACf,aAAa;CACb,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf","sourcesContent":[".provide-feedback {\n\tpadding: 16px;\n\tfont-size: 15px;\n}\n\n.provide-feedback select {\n\theight: 36px;\n\tborder: 1px solid #999;\n\tfont-size: 14px;\n\tmargin: 8px 0;\n\tborder-radius: 5px;\n\tbox-sizing: border-box;\n}\n\n.provide-feedback button[type=submit] {\n\tborder: 1px solid #4f638d;\n\tbackground: #4f638d;\n\tcolor: #FFF;\n\theight: 36px;\n\tfont-size: 17px;\n\tline-height: 36px;\n\tborder-radius: 5px;\n\tpadding: 0 20px;\n\tbox-sizing: border-box;\n\tcursor: pointer;\n}\n\n.provide-feedback textarea {\n\twidth: 100%;\n\tborder: 1px solid #999;\n\tfont-size: 14px;\n\tmargin-bottom: 8px;\n\tborder-radius: 5px;\n\tbox-sizing: border-box;\n}\n\n.provide-feedback .success {\n\tcolor: #0B6623;\n}\n\n.provide-feedback .error {\n\tcolor: #AB1F2B;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
